import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f3d96488&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f3d96488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d96488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3d96488')) {
      api.createRecord('f3d96488', component.options)
    } else {
      api.reload('f3d96488', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f3d96488&scoped=true&", function () {
      api.rerender('f3d96488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BNSXqP314bTI/JS/comp/SearchFilterTokens.vue"
export default component.exports